"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: Boolean | Object,
    collapsible: Boolean,
    contentUrls: Array,
    dataContentField: String,
    dataContentUrlField: String,
    dataImageUrlField: String,
    dataSource: Object | Array,
    dataSpriteCssClass: String,
    dataTextField: String,
    dataUrlField: String,
    navigatable: Boolean,
    scrollable: Boolean | Object,
    tabPosition: String,
    value: String,

    // Events
    activate: Function,
    contentLoad: Function,
    error: Function,
    select: Function,
    show: Function
};